import * as React from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector, useDispatch } from "react-redux";
import {
  bank_icon_2,
  bank_method_icon,
  cash_bank_icon,
  cash_icon_2,
  cash_method_icon,
  clear_icon,
  credit,
  credit_blue,
  delivery_icon,
  return_icon,
} from "../../assets";
import { createOrder } from "../../Redux/Action/createposorderAction";
import { useTranslation } from "react-i18next";
import { storeSelectedPaymentMethod } from "../../Redux/Action/paymentAction";
import { toast } from "react-toastify";
import i18next from "i18next";
import { detectWebDeviceType, isTablet } from "../../utils";
import SelectBox from "../CustomWidgets/SelectBox";
// import LoadingSpinner from './LoadingSpinner'; // Import LoadingSpinner component

const LoadingSpinner = () => {
  return (
    <div
      style={{ zIndex: 50 }}
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50"
    >
      <div className="spinner">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};

function OrderFromButton({ paymentMethod, selected, onClick, disabled }) {
  const { t, i18n } = useTranslation();

  // const getIcon = (method) => {
  //   switch (method) {
  //     case "Cash":
  //       // return cash_method_icon;
  //       return cash_icon_2;
  //     case "Bank":
  //       return bank_icon_2;
  //     // return bank_method_icon;
  //     case "Delivery":
  //       return delivery_icon;
  //     case "Cash & Bank":
  //       return cash_bank_icon;
  //     case "Credit Card":
  //       return bank_icon_2;
  //     case "InstaPay":
  //       return bank_icon_2;
  //     case "Credit":
  //       return credit_blue;

  //     default:
  //       return null;
  //   }
  // };

  const getPaymentMethodName = (method) => {
    switch (method) {
      case "self_delivery":
        return t("Self Delivery");
      default:
        return t(method);
    }
  };
  // console.log("paymentMethod",paymentMethod);

  return (
    <div
      className={`flex items-center  justify-center  gap-2 mt-5 px-8 py-5 text-l font-semibold rounded-xl border-2 border-solid shadow-sm cursor-pointer whitespace-nowrap ${
        selected ? " border-blue-900 border-4" : ""
      } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundColor: paymentMethod?.background_color
          ? paymentMethod?.background_color
          : "#7EC242",
        color: paymentMethod?.text_color ? paymentMethod?.text_color : "#fff",
      }}
    >
      {/* {getIcon(paymentMethod.name) && (
        <img
          src={getIcon(paymentMethod.name)}
          alt={`${paymentMethod.name} icon`}
          className={`w-10  ${selected ? "" : "filter grayscale"}`}
        />
      )} */}
      {getPaymentMethodName(paymentMethod.name)}
    </div>
  );
}

function PaymentButton({ paymentMethod, selected, onClick, disabled }) {
  const { t } = useTranslation();
  const deviceType = detectWebDeviceType();

  const getIcon = (method) => {
    switch (method) {
      case "Cash":
        return cash_icon_2;
      case "Bank":
        return bank_icon_2;
      case "COD":
        return delivery_icon;
      case "Cash & Bank":
        return cash_bank_icon;
      case "Credit Card":
        return bank_icon_2;
      case "InstaPay":
        return bank_icon_2;
      case "Credit":
        return credit_blue;
      default:
        return bank_icon_2;
    }
  };

  const getPaymentMethodName = (method) => {
    switch (method) {
      case "Cash":
        return t("Cash");
      case "Bank":
        return t("Bank");
      case "COD":
        return t("COD");
      case "Cash & Bank":
        return t("Cash & Bank");
      case "Credit Card":
        return t("Credit Card");
      case "InstaPay":
        return t("InstaPay");
      case "Credit":
        return t("Credit");
      default:
        return t(method);
    }
  };

  return (
    <div
      className={`flex flex-col items-center justify-center py-2 text-md font-semibold rounded-lg border-2 shadow-sm cursor-pointer 
      text-center break-words min-h-[60px]
      ${
        selected
          ? "text-blue-900 bg-white border-blue-900"
          : "bg-white border-stone-300 text-zinc-600"
      }
      ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      onClick={!disabled ? onClick : undefined}
    >
      {/* {getIcon(paymentMethod.name) && deviceType !== "tablet" && (
        <img
          src={getIcon(paymentMethod.name)}
          alt={`${paymentMethod.name} icon`}
          className={`w-9 h-7  ${selected ? "" : "filter grayscale"}`}
        />
      )} */}

      <span className="text-center leading-tight">
        {getPaymentMethodName(paymentMethod.name)}
      </span>
    </div>
  );
}

function KeypadButton({
  value,
  className,
  onClick,
  children,
  isBankPaymentSelected,
  grandTotal,
  selectedPaymentMethod,
  orderFromOptions,
}) {
  const deviceType = detectWebDeviceType();

  return (
    <button
      type="button"
      className={`flex justify-center items-center ${
        deviceType == "tablet"
          ? "h-[83px]"
          : orderFromOptions.length > 0
            ? "h-[83px]"
            : "h-[83px]"
      } w-40 rounded ${
        isBankPaymentSelected ||
        grandTotal < 0 ||
        selectedPaymentMethod?.name === "COD" ||
        selectedPaymentMethod?.name === "Credit"
          ? "opacity-50"
          : ""
      } ${className}`}
      onClick={
        isBankPaymentSelected || selectedPaymentMethod?.name === "COD"
          ? null
          : onClick
      }
      // className={`flex justify-center items-center h-[93px] w-40 rounded ${
      //   isBankPaymentSelected ||
      //   grandTotal < 0 ||
      //   selectedPaymentMethod?.name == "Delivery" ||
      //   selectedPaymentMethod?.name == "Credit"
      //     ? "opacity-50"
      //     : ""
      // } ${className}`}
      // onClick={
      //   isBankPaymentSelected || selectedPaymentMethod?.name == "Delivery"
      //     ? null
      //     : onClick
      // }
      disabled={
        isBankPaymentSelected ||
        grandTotal < 0 ||
        selectedPaymentMethod?.name == "COD" ||
        selectedPaymentMethod?.name == "Credit"
      }
      style={{
        marginInlineEnd: 12, // Adds horizontal spacing (LTR/RTL support)
      }}
    >
      {children || value}
    </button>
  );
}
const dummyPaymentMethods = [
  // { name: "Cash" },
  // { name: "Bank" },
  { name: "COD" },
  { name: "Cash & Bank" },
  // { name: "InstaPay" },
  // { name: "Credit Card" },

  { name: "Credit" },
];

function Payment_Modal({
  onClose,
  isCompanyCheckout,
  grandTotal,
  handleCheckout,
  setTenderCash,
  creditAmount,
  setCreditAmount,
  deliveryCheck,
  deliveryFee,
  setDeliveryFee,
  returnDeliveryFee,
  setReturnDeliveryFee,
  showReturnDelivery,
  constReturnDeliveryFee,
  discountType,
  setDiscountType,
  discountValue,
  setDiscountValue,
  originalTotal,
  totalBillAmount,
  totalCostPrice,
}) {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();

  const { user } = useSelector((state) => state?.login);
  const [totalPaid, setTotalPaid] = useState("");
  const [ReturnTotal, setReturnTotal] = useState("");
  const [change, setChange] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();

  const [isBankPaymentSelected, setIsBankPaymentSelected] = useState(false);
  // const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [orderFromOptions, setOrderFromOptions] = useState([]);
  const [allSalesman, setAllSalesman] = useState([]);
  const [selectedSalesman, setSelectedSalesman] = useState(null);
  const [selectedOrderFrom, setSelectedOrderFrom] = useState();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [activePaymentIndex, setActivePaymentIndex] = useState(0);
  const [activeOrderFromIndex, setActiveOrderFromIndex] = useState("");
  const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled,
  );
  const returnProducts = useSelector(
    (state) => state.returnProductReducer.products,
  );

  const allowDiscount = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_allow_discount,
  );
  const localProducts = useSelector((state) => state.products.products);

  const [cashPaid, setCashPaid] = useState(0);
  const [remainingAmount, setRemainingAmount] = useState(grandTotal);
  const totalPaidInputRef = React.useRef(null);
  const getCustomerState = useSelector(
    (state) => state?.getcustomer?.selectedCustomer,
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

  console.log("localProducts==>", localProducts);

  const dispatch = useDispatch();

  const calculateTotalTax = (products) => {
    return products.reduce((total, product) => {
      const price = Number(product.price_after_discount) || 0;
      const qty = Number(product.quantity) || 1;

      const taxPercentage =
        isETAenabled && product?.vat_details?.tax_id
          ? Number(product?.vat_details?.tax_rate_percent) || 0
          : 0;

      const tax = (price * qty * taxPercentage) / (100 + taxPercentage);

      return total + tax;
    }, 0);
  };

  const totalTax = calculateTotalTax(localProducts);

  console.log("totalTax===>", totalTax);

  const getPaymentMethod = async (userID) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.PAYMENT_METHODS, {
        user_id: userID,
      });

      if (response?.data.result.data != null) {
        const methods = response.data.result.data.map((method) => ({
          name: method.name,
          id: method.id,
          is_cash_bank: method.is_cash_bank,
          cash_id: method.cash_payment_method_id,
          bank_id: method.bank_id ?? method.bank_payment_method_id,
        }));

        setPaymentMethods([...methods]);

        let selectedIndex;

        if (grandTotal <= 0 && returnProducts?.[0]?.payment_method_id) {
          selectedIndex = methods.findIndex((method) => {
            const sameId = method.id === returnProducts?.[0]?.payment_method_id;

            const hasBankId =
              returnProducts?.[0]?.bank_id != null && method.bank_id != null;

            if (sameId && hasBankId) {
              return method.bank_id === returnProducts?.[0]?.bank_id;
            }

            return sameId;
          });
        } else {
          selectedIndex = methods.findIndex((method) => method.name === "Cash");
        }

        if (selectedIndex !== -1) {
          const selectedMethod = methods[selectedIndex];

          handlePaymentMethodClick(selectedMethod, selectedOrderFrom);
          setSelectedPaymentMethod(selectedMethod);
          setActivePaymentIndex(selectedIndex);
        }
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed to fetch payment methods.");
    } finally {
      setLoading(false);
    }
  };

  const getOrderFrom = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.ORDER_FROM, {
        user_id: user_id,
        lang: i18next.language === "ar" ? "ar_001" : "en_US",
      });

      const posOrderFrom = response?.data?.result?.[0]?.pos_order_from;

      setOrderFromOptions(posOrderFrom);
      setSelectedOrderFrom(posOrderFrom[0]);
      setActiveOrderFromIndex(0);
      getOrderFromMethods(posOrderFrom[0]?.id, posOrderFrom[0]);
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed to fetch order from options.");
    } finally {
      setLoading(false);
    }
  };

  const getSalesman = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_ALL_SALESMAN, {
        lang: i18next.language === "ar" ? "ar_001" : "en_US",
        company_id: user?.result?.company_id,
        search: "",
        limit: 100,
        offset: 0,
      });

      // const posOrderFrom = response?.data?.result?.[0]?.pos_order_from;
      if (response?.data?.result?.status_code == 200) {
        setAllSalesman(response?.data?.result?.data);
      } else {
        setAllSalesman([]);
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed to fetch order from options.");
    } finally {
      setLoading(false);
    }
  };

  const getOrderFromMethods = async (id, company) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.ORDER_FROM_METHOD, {
        user_id: user_id,
        pos_order_from_id: id,
      });
      if (response?.data?.result?.status_code == 200) {
        setPaymentMethods(response?.data?.result?.data);
        const cashIndex = response?.data?.result?.data?.findIndex(
          (method) => method.name === "Cash",
        );
        console.log("cashIndex===>", company);

        if (cashIndex !== -1) {
          handlePaymentMethodClick(
            response?.data?.result?.data[cashIndex],
            company,
          );
          setSelectedPaymentMethod(response?.data?.result?.data[cashIndex]);
          setActivePaymentIndex(cashIndex); // set index of "Cash"
        } else {
          handlePaymentMethodClick(response?.data?.result?.data[0], company);
        }
      } else {
        setPaymentMethods([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getCreditAomunt = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_CUSTOMER_CREDIT, {
        phone: getCustomerState?.mobile,
      });

      if (
        response?.data?.result[0].status_code === 200 &&
        response?.data?.result[0].status === "Customer Credits"
      ) {
        setCreditAmount(response?.data?.result[0]);
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed to fetch credit amount.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (isCompanyCheckout) {
      getOrderFrom();
    }
  }, [user?.result?.user_id]);

  useEffect(() => {
    if (!deliveryCheck && !isCompanyCheckout) {
      getPaymentMethod(user?.result?.user_id);
    }

    getSalesman();
    if (getCustomerState) {
      getCreditAomunt();
    }
  }, [user?.result?.user_id, getCustomerState]);

  const keypadValues = [
    [
      {
        value: "1",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "2",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "3",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "10",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
    ],
    [
      {
        value: "4",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "5",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "6",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "20",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
    ],
    [
      {
        value: "7",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "8",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "9",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "50",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
    ],
    [
      {
        value: ".",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "0",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "200",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
      {
        value: "100",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
    ],
  ];

  const handleKeypadButtonClick = (value) => {
    if (
      totalPaid.length >= 10 &&
      value !== "C" &&
      value !== "." &&
      !["50", "100", "200"].includes(value)
    ) {
      return;
    }

    if (value === "C") {
      setTotalPaid("");
      setTenderCash(0);
      setChange("");
    } else if (value === ".") {
      if (!totalPaid.includes(".")) {
        setTotalPaid((prevTotalPaid) => prevTotalPaid + ".");
        setTenderCash((prevTotalPaid) => prevTotalPaid + "." || 0);
      }
    } else if (!isNaN(parseInt(value, 10))) {
      if (["50", "100", "200", "20", "10"].includes(value)) {
        const updatedTotalPaid = parseFloat(totalPaid || 0) + parseFloat(value);
        setTotalPaid(updatedTotalPaid.toString());
        setTenderCash(updatedTotalPaid.toString() || 0);
        const changeNumeric =
          updatedTotalPaid -
          parseFloat(String(grandTotal).replace(/[^0-9.]/g, ""));
        setChange(`${Math.max(changeNumeric, 0)}`);
      } else {
        const updatedTotalPaid = totalPaid + value;
        setTotalPaid(updatedTotalPaid);
        setTenderCash(updatedTotalPaid || 0);
        const numericValue = parseFloat(
          updatedTotalPaid.replace(/[^0-9.]/g, ""),
        );
        const changeNumeric =
          numericValue - parseFloat(String(grandTotal).replace(/[^0-9.]/g, ""));
        setChange(`${Math.max(changeNumeric, 0)}`);
      }

      if (selectedPaymentMethod?.name === "Cash & Bank") {
        const updatedTotalPaid = totalPaid + value;
        const numericValue = parseFloat(
          updatedTotalPaid.replace(/[^0-9.]/g, ""),
        );

        const remainingAmount = grandTotal - numericValue;
        setRemainingAmount(Math.max(remainingAmount, 0)); // Ensure it's not negative
      }
    }
    setErrorMessage("");
  };

  const handlePaymentMethodClick = (method, company) => {
    console.log("companyName==>", company?.name, company?.delivery_fee);
    console.log("METRHOFFFFFFFF==>", method);

    if (grandTotal <= 0) setTotalPaid(0);
    if (company?.name === "self_delivery") {
      setDeliveryFee(company?.delivery_fee ? company?.delivery_fee : 0);
    } else if (method.name === "COD") {
      setDeliveryFee(
        selectedOrderFrom?.delivery_fee ? selectedOrderFrom?.delivery_fee : 0,
      ); // Reset delivery fee when selecting Delivery
    } else {
      setDeliveryFee(null);
    }
    // if (
    //   (grandTotal <= 0 && method.name === "Bank") ||
    //   (grandTotal <= 0 && method.name === "Credit Card") ||
    //   (grandTotal <= 0 && method.name === "InstaPay") ||
    //   (grandTotal <= 0 && method.name === "Cash & Bank") ||
    //   (grandTotal <= 0 && method.bank_id) ||
    //   (grandTotal <= 0 && method.name === "COD")
    // )
    //   return;
    dispatch(storeSelectedPaymentMethod(method));
    setSelectedPaymentMethod(method);
    setActivePaymentIndex(paymentMethods.indexOf(method));

    if (method.name === "Cash & Bank") {
      console.log("SELEDTED METHODDD--->", paymentMethods);

      const cashMethod = paymentMethods?.find((m) => m.name === "Cash");
      const bankMethod = paymentMethods?.find(
        (m) => m.name === "Bank" || m.bank_id,
      );

      if (cashMethod && bankMethod) {
        // Set the selected payment method to include both IDs
        method = {
          name: method.name,
          id: {
            cashId: cashMethod.id,
            bankId: bankMethod.id,
          },
        };
        setSelectedPaymentMethod(method);
      }
      setIsBankPaymentSelected(false);
      setCashPaid(0); // Reset cash paid
      setRemainingAmount(grandTotal); // Set remaining amount to grand total
      setTotalPaid(""); // Clear total paid input
      setChange(""); // Clear change
    } else if (
      method.name === "Bank" ||
      method.name === "Credit Card" ||
      method.name === "InstaPay" ||
      method.bank_id ||
      method?.name == "COD" ||
      method?.name === "Fawry" ||
      method?.name === "Prepaid" ||
      method?.name === "PayU" ||
      method?.name === "Vodafone Cash" ||
      method?.name === "ValU"
    ) {
      setIsBankPaymentSelected(true);
      setTenderCash(String(grandTotal) || 0);
      setTotalPaid(String(grandTotal));
      setChange("0");
    } else if (method.name === "COD") {
      const cashMethod = paymentMethods.find((m) => m.name === "Cash");
      if (cashMethod) {
        method = {
          name: method.name,
          id: cashMethod.id, // Pass the ID of the Cash method
        };
        setSelectedPaymentMethod(method);
      }

      setIsBankPaymentSelected(false);
      // setTenderCash(String(grandTotal));
      setTotalPaid(0);
      setTenderCash(0);
      setChange("0");
    } else if (method.name === "Credit") {
      // console.log("CRREEDITITTTTTTT=======================");

      setIsBankPaymentSelected(false);
      setTotalPaid(0);
      setTenderCash(0);
      setChange("0");
    } else {
      setIsBankPaymentSelected(false);
      setTenderCash(0);
      setTotalPaid("");
      setChange("");
    }
    setErrorMessage("");
  };

  const handleOrderFromClick = (method) => {
    if (selectedOrderFrom?.id === method?.id) {
      return;
    } else {
      getOrderFromMethods(method?.id, method);
      setSelectedOrderFrom(method);
      setActiveOrderFromIndex(orderFromOptions.indexOf(method));
    }
  };

  const handleCheckoutClick = (event) => {
    // console.log("SELECTED PM", selectedPaymentMethod);
    if (errorMessage) {
      toast.error(
        t(
          `The Return Delivery Fee cannot exceed EGP ${constReturnDeliveryFee}`,
        ),
      );
      return;
    }

    handleCheckout(selectedPaymentMethod, selectedOrderFrom, selectedSalesman);
  };

  const handleClearButtonClick = () => {
    if (!isBankPaymentSelected) {
      setTotalPaid("");
      setChange("");
      setRemainingAmount(0);
      setDiscountType("");
      setDiscountValue(0);
    }
  };

  useEffect(() => {
    if (grandTotal < 0) {
      setTotalPaid(grandTotal.toString());
      setIsBankPaymentSelected(true);
    }
  }, [grandTotal]);

  const handleKeyPress = (event) => {
    const normalizedKey =
      {
        // ش: "Enter", // Arabic "ش" is similar to English "Enter"
        x: "ء", // Arabic "Ctrl+X" will be normalized to "x" when Ctrl is pressed
      }[event.key] || event.key; // Fallback to the original key if no mapping exists

    if (event.key === "Enter") {
      event.preventDefault();
      if (
        selectedPaymentMethod?.name === "Cash & Bank" &&
        totalPaid >= grandTotal
      ) {
        return;
      }
      if (
        (selectedPaymentMethod?.name === "Cash & Bank" && totalPaid > 0) ||
        (selectedPaymentMethod?.name === "Cash" && totalPaid >= grandTotal)
      ) {
        handleCheckoutClick(event);
      } else if (
        selectedPaymentMethod?.name === "Bank" &&
        totalPaid == grandTotal
      ) {
        handleCheckoutClick(event);
      } else if (selectedPaymentMethod?.name === "COD") {
        handleCheckoutClick(event);
      } else if (selectedPaymentMethod?.name === "Credit") {
        handleCheckoutClick(event);
      }
      // if (totalPaid > grandTotal || totalPaid == grandTotal)
      //   handleCheckoutClick(event);
    } else if (event.shiftKey && normalizedKey === "Shift") {
      event.preventDefault();
      if (
        (grandTotal <= 0 && selectedPaymentMethod?.name === "Bank") ||
        grandTotal <= 0
      ) {
        return;
      }

      const nextIndex = (activePaymentIndex + 1) % paymentMethods.length;
      setActivePaymentIndex(nextIndex);
      setSelectedPaymentMethod(paymentMethods[nextIndex]);
      handlePaymentMethodClick(paymentMethods[nextIndex], selectedOrderFrom);
    } else if (event.ctrlKey && normalizedKey === "ء") {
      // Handle Ctrl+X
      event.preventDefault();
      handleClearButtonClick();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [
    totalPaid,
    grandTotal,
    selectedPaymentMethod,
    activePaymentIndex,
    handleClearButtonClick,
  ]);

  useEffect(() => {
    if (
      selectedPaymentMethod?.name === "Cash" ||
      selectedPaymentMethod?.name === "Cash & Bank"
    ) {
      totalPaidInputRef.current?.focus(); // Focus the input field
    }
  }, [selectedPaymentMethod]);

  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 backdrop-blur-md drop-shadow-sm">
      {loading && <LoadingSpinner />}

      <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
      <section
        className="relative flex flex-col py-10 text-lg font-semibold  bg-white rounded-[15px] text-zinc-800 max-md:px-5 z-40 mt-8"
        style={{ width: isCompanyCheckout ? "1520px" : "1350px" }}
      >
        <button
          type="button"
          onClick={onClose}
          className={`bg-transparent absolute top-4 text-zinc-800" ${i18n.language === "ar" ? "left-3" : "right-3"}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <main className="flex">
          {isCompanyCheckout && (
            <div className=" border-e border-[#D9D9D9] px-6">
              <div className="text-xl font-semibold tracking-wider text-[#5C5C5C]">
                {t("Company Delivery")}
              </div>
              <div className="justify-center w-full mt-8">
                {orderFromOptions.map((method, index) => {
                  return (
                    <OrderFromButton
                      key={method.id}
                      paymentMethod={method}
                      selected={selectedOrderFrom?.id === method.id}
                      onClick={() => handleOrderFromClick(method)}
                      disabled={grandTotal <= 0}
                    />
                  );
                  // }
                  // return null;
                })}
              </div>
            </div>
          )}

          <div className="flex ms-5 flex-1 gap-7 max-md:flex-col">
            <div className="flex flex-col w-5/12 max-md:w-full h-full">
              <div className="flex flex-col gap-3 h-full">
                {totalBillAmount != grandTotal && (
                  <div className="text-2xl mb-4 font-semibold tracking-wider text-[#5C5C5C]">
                    {t("Total Bill")}
                  </div>
                )}

                <div className="text-2xl font-semibold tracking-wider text-[#5C5C5C]">
                  {t("Grand Total")}
                </div>

                {/* {(
                  (isCompanyCheckout && selectedOrderFrom?.name === "self_delivery" && allowDiscount) ||
                  (!isCompanyCheckout && allowDiscount)
                ) && (<div className="text-2xl mt-3 font-semibold tracking-wider text-[#5C5C5C]">
                  {t("Discount Applied")}
                </div>
                  )} */}

                <div className="text-2xl font-bold mt-5 tracking-wider text-[#5C5C5C] mt-2">
                  {/* {t("Total Paid")} */}
                  {selectedPaymentMethod?.name === "Cash & Bank"
                    ? t("Total paid by cash")
                    : t("Total Paid")}
                </div>
                {grandTotal > 0 && (
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {/* {t("Change")} */}
                    {selectedPaymentMethod?.name === "Cash & Bank"
                      ? t("Total paid by bank")
                      : t("Change")}
                  </div>
                )}
                {creditAmount?.response && (
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {t("Balance Credit Amount")}
                  </div>
                )}

                {showReturnDelivery && (
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {t("Refund Delivery Fee")}
                  </div>
                )}

                {(selectedOrderFrom?.name === "self_delivery" ||
                  selectedPaymentMethod?.name === "COD") && (
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {t("Delivery Fee")}
                  </div>
                )}
              
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {t("Salesman")}
                  </div>
                <div className="flex flex-col capitalize max-md:flex-wrap">
                  <span className="mt-2 text-gray-600 italic mb-2">
                    {t("Payment Options")}
                  </span>
                  <div className="grid grid-cols-3 gap-2 w-full ms-3">
                    {paymentMethods?.map((method, index) => {
                      return (
                        <PaymentButton
                          key={method.id}
                          paymentMethod={method}
                          selected={
                            selectedPaymentMethod?.name === method.name ||
                            activePaymentIndex === index
                          }
                          onClick={() =>
                            handlePaymentMethodClick(method, selectedOrderFrom)
                          }
                          // disabled={grandTotal <= 0 && method.name !== "Cash"}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className="flex-grow"></div>
                <button
                  disabled={
                    (selectedPaymentMethod?.name === "Cash & Bank" &&
                      totalPaid <= 0) ||
                    (selectedPaymentMethod?.name === "Cash" &&
                      totalPaid < grandTotal) ||
                    (selectedPaymentMethod?.name === "Cash & Bank" &&
                      totalPaid >= grandTotal)
                  }
                  onClick={handleCheckoutClick}
                  className={`justify-center items-center  me-2.5 text-3xl text-center text-white capitalize whitespace-nowrap bg-[#1b4597] rounded-lg max-md:px-5 max-md:mt-10 max-md:max-w-full ${
                    orderFromOptions.length > 0 ? "py-[9%]" : "py-[9%]"
                  }`}
                  style={{
                    opacity:
                      (selectedPaymentMethod?.name === "Cash & Bank" &&
                        totalPaid <= 0) ||
                      (selectedPaymentMethod?.name === "Cash & Bank" &&
                        totalPaid >= grandTotal) ||
                      (selectedPaymentMethod?.name === "Cash" &&
                        totalPaid < grandTotal)
                        ? 0.5
                        : 1,
                  }}
                >
                  {t("Done")}
                </button>
              </div>
            </div>

            <div className="flex flex-col w-7/12 max-md:w-full -me-24">
              {/* Tota Paid  */}

              {/* Total Bill  */}
              <div
                className="flex flex-row gap-8"
                dir={i18n.language === "ar" ? "rtl" : "ltr"}
              >
                <div>
                  {totalBillAmount != grandTotal && (
                    <div
                      className={`flex h-[40px] mb-4 overflow-hidden w-7/12 justify-center items-start ${
                        i18n.language === "ar" ? "flex-row-reverse " : ""
                      }`}
                    >
                      <span className="inset-y-0 flex items-center pl-3 text-2xl text-black">
                        EGP
                      </span>
                      <input
                        type="number"
                        className="text-left  w-full px-5 font-bold text-zinc-800 text-2xl"
                        value={
                          i18n.language === "ar" && totalBillAmount < 0
                            ? `${-totalBillAmount.toFixed(2)}-`
                            : parseFloat(totalBillAmount).toFixed(2)
                        }
                        readOnly
                      />
                    </div>
                  )}

                  {/* Grand Total  */}

                  <div
                    className={`flex h-[40px] overflow-hidden w-10/12 justify-start items-center ${
                      i18n.language === "ar" ? "flex-row-reverse " : ""
                    }`}
                  >
                    <span className="inset-y-0 flex items-center pl-3 text-2xl text-black">
                      EGP
                    </span>
                    <span className="inset-y-0 flex items-center pl-3 text-2xl text-black">
                      {i18n.language === "ar" && grandTotal < 0
                        ? `${-grandTotal.toFixed(2)}-`
                        : parseFloat(grandTotal).toFixed(2)}
                    </span>
                    {/* <input
                      type="number"
                      className="text-left  w-full px-5 font-bold text-zinc-800 text-2xl"

                      value={
                        i18n.language === "ar" && grandTotal < 0
                          ? `${-grandTotal.toFixed(2)}-`
                          : parseFloat(grandTotal).toFixed(2)
                      }
                      readOnly
                    /> */}
                    {isETAenabled && (
                      <span className="inset-y-0 flex items-center pl-3 text-2xl text-gray-600 ">{`(Tax: EGP ${totalTax.toFixed(2)})`}</span>
                    )}
                  </div>

                  {/* Discount Applied Section */}
                  {/* {(
                    (isCompanyCheckout && selectedOrderFrom?.name === "self_delivery" && allowDiscount) ||
                    (!isCompanyCheckout && allowDiscount)
                  ) && (
                  <div className="mt-2 mb-4">

                    <div className="flex items-center gap-5">

                      <label className="flex items-center gap-2 text-xl">
                        <input
                          type="radio"
                          name="discountType"
                          value="percentage"
                          checked={discountType === "percentage"}
                          onChange={() => {
                            setDiscountType("percentage");
                            setDiscountValue("");
                          }}
                          className="h-5 w-5"
                        />
                        {t("Percentage")}
                      </label>

                      <label className="flex items-center gap-2 text-xl">
                        <input
                          type="radio"
                          name="discountType"
                          value="value"
                          checked={discountType === "value"}
                          onChange={() => {
                            setDiscountType("value");
                            setDiscountValue("");
                          }}
                          className="h-5 w-5"
                        />
                        {t("Value")}
                      </label>

                      {discountType && (
                        <div className="relative w-[250px]">

                          {discountType === "value" && (
                            <span
                              className={`absolute inset-y-0  flex items-center text-xl text-gray-600 ${i18n.language === "ar" ? "right-3" : "left-3"}`}
                            >
                              EGP
                            </span>
                          )}

                          <input
                            type="number"
                            placeholder={
                              discountType === "percentage"
                                ? t("Enter %")
                                : t("Enter amount")
                            }
                            className={`border border-gray-300 rounded-lg  pe-3 py-2 w-full text-xl focus:outline-none focus:border-1px ${discountType === "percentage" ? "ps-4" : "ps-14"}`}
                            value={discountValue}

                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e" || e.key === "E") {
                                e.preventDefault();
                              }
                            }}


                            onChange={(e) => {
                              let value = e.target.value;

                              value = value.replace(/[^0-9.]/g, "");

                              value = value.replace(/(\..*)\./g, "$1");

                              if (value.includes(".")) {
                                const [intPart, decimalPart] = value.split(".");
                                if (decimalPart.length > 2) {
                                  return; // block input
                                }
                              }

                              let numeric = parseFloat(value);

                              if (isNaN(numeric)) {
                                setDiscountValue("");
                                return;
                              }

                              if (discountType === "value") {
                                if ((originalTotal - numeric) < totalCostPrice) {
                                  toast.error(t("The Discount price cannot be less than the Cost price"));
                                  return;
                                }
                              }
                              console.log("totalCostPrice--->", totalCostPrice);
                          const percentSalePrice = originalTotal - ((originalTotal * numeric)/100);

                              if (discountType === "percentage") {
                                if (percentSalePrice < totalCostPrice) {
                                  toast.error(t("The Discount price cannot be less than the Cost price"));
                                  return;
                                }
                              }

                              if (selectedPaymentMethod?.name === "Cash & Bank") {
                                setTotalPaid("");
                                setRemainingAmount(0)
                              }
                              if (selectedOrderFrom?.name === "self_delivery") {
                                if (numeric > (originalTotal - deliveryFee)) {
                                  toast.error(t("The Discount price cannot be less than the Cost price"));
                                  return;
                                }
                              }



                              setDiscountValue(value);
                            }}

                          />
                        </div>
                      )}

                    </div>
                  </div>
                    )} */}

                  <div className="flex align-middle justify-between w-full  ">
                    <div
                      className={`flex bg-white mt-1 w-[400px] rounded-lg h-[60px] overflow-hidden justify-center items-start ${
                        isBankPaymentSelected ||
                        grandTotal < 0 ||
                        selectedPaymentMethod?.name === "COD" ||
                        selectedPaymentMethod?.name === "Credit" ||
                        selectedPaymentMethod?.name === "ValU" ||
                        selectedPaymentMethod?.name === "Vodafone Cash" ||
                        selectedPaymentMethod?.name === "Fawry" ||
                        selectedPaymentMethod?.name === "Prepaid" ||
                        selectedPaymentMethod?.name === "PayU"
                          ? "" // No border class
                          : "border border-solid border-stone-300" // Apply border class
                      } ${i18n.language === "ar" ? "flex-row-reverse" : ""}`}
                    >
                      <span
                        className={`inset-y-0 flex items-center py-3.5 text-2xl text-black" ${i18n.language === "ar" ? "px-6" : "px-3"}`}
                      >
                        EGP
                      </span>
                      <input
                        id="textInput1"
                        ref={totalPaidInputRef}
                        type="number"
                        autoFocus={true}
                        //  readOnly={true}
                        onFocus={
                          deviceType === "tablet"
                            ? (e) => e.target.blur()
                            : undefined
                        }
                        className="bg-white text-left h-[62px] w-full focus:outline-none  font-bold text-zinc-800 text-2xl"
                        value={
                          isBankPaymentSelected
                            ? grandTotal.toFixed(2)
                            : grandTotal <= 0
                              ? "0"
                              : totalPaid
                        }
                        readOnly={
                          isBankPaymentSelected ||
                          grandTotal < 0 ||
                          selectedPaymentMethod?.name == "COD" ||
                          selectedPaymentMethod?.name == "Credit" ||
                          selectedPaymentMethod?.name === "Fawry" ||
                          selectedPaymentMethod?.name === "Prepaid" ||
                          selectedPaymentMethod?.name === "PayU"
                        }
                        style={{ direction: "ltr" }}
                        onChange={(e) => {
                          // Get the input value
                          let inputValue = e.target.value;

                          // Replace Arabic decimal separator with a period
                          inputValue = inputValue.replace(/ز/g, ".");

                          // Remove any non-numeric characters except the decimal point
                          const sanitizedValue = inputValue.replace(
                            /[^0-9.]/g,
                            "",
                          );

                          // Validate the sanitized value
                          if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
                            setTotalPaid(sanitizedValue);
                            setTenderCash(sanitizedValue || 0);

                            // Calculate the change
                            const numericValue =
                              parseFloat(sanitizedValue) || 0;
                            const grandTotalValue =
                              parseFloat(
                                String(grandTotal).replace(/[^0-9.]/g, ""),
                              ) || 0;
                            const changeNumeric =
                              numericValue - grandTotalValue;

                            // Set the change ensuring it's not negative
                            setChange(`${Math.max(changeNumeric, 0)}`);

                            if (selectedPaymentMethod?.name === "Cash & Bank") {
                              const remainingAmount =
                                grandTotalValue - numericValue;
                              setRemainingAmount(Math.max(remainingAmount, 0)); // Ensure it's not negative
                            }
                          }
                        }}
                        maxLength={7}
                      />
                    </div>
                    <button
                      className={`justify-center items-center text-xl text-white bg-[#F42020] ms-3 mt-1 w-[250px] h-[60px] rounded-lg border border-solid border-stone-300 max-md:px-5 ${
                        isBankPaymentSelected ||
                        selectedPaymentMethod?.name === "Credit" ||
                        selectedPaymentMethod?.name === "COD" ||
                        grandTotal < 0
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                      onClick={
                        isBankPaymentSelected ||
                        selectedPaymentMethod?.name === "Credit" ||
                        selectedPaymentMethod?.name === "COD"
                          ? null
                          : handleClearButtonClick
                      }
                      style={{
                        opacity:
                          isBankPaymentSelected ||
                          selectedPaymentMethod?.name === "Credit" ||
                          selectedPaymentMethod?.name === "COD" ||
                          grandTotal < 0
                            ? 0.5
                            : 1,
                      }} // Apply inline style for opacity
                    >
                      {t("Clear")}
                    </button>
                  </div>

                  {grandTotal > 0 && (
                    <div
                      className={`flex rounded-lg mt-2  w-7/12 h-[60px] overflow-hidden justify-center items-start ${
                        i18n.language === "ar" ? "flex-row-reverse " : ""
                      }`}
                    >
                      <span className="inset-y-0 flex  items-center px-3 py-3.5 text-2xl text-black">
                        EGP
                      </span>

                      <input
                        type="number"
                        className="text-left h-[62px]  w-full focus:outline-none px-3 font-bold text-zinc-800 text-2xl"
                        value={
                          selectedPaymentMethod?.name === "Cash & Bank"
                            ? `${remainingAmount.toFixed(2)}`
                            : i18n.language === "ar" && grandTotal < 0
                              ? `${-grandTotal.toFixed(2)}-`
                              : grandTotal < 0
                                ? grandTotal.toFixed(2) // Display grandTotal when it's less than 0
                                : Number(change)?.toFixed(2) // Format change with two decimal places
                        }
                        readOnly
                      />
                    </div>
                  )}
                  {creditAmount?.response && (
                    <div
                      className={`flex rounded-lg mt-2  w-[300px] h-[60px] overflow-hidden justify-center items-start ${
                        i18n.language === "ar" ? "flex-row-reverse ms-10" : ""
                      }`}
                    >
                      <span className="inset-y-0 flex items-center pl-3 py-3.5 text-2xl text-black">
                        EGP
                      </span>

                      <input
                        type="number"
                        className="text-left h-[62px] w-full focus:outline-none px-2 font-bold text-zinc-800 text-2xl"
                        value={creditAmount?.response}
                        readOnly
                      />
                    </div>
                  )}

                  {showReturnDelivery && (
                    <div
                      className={`flex bg-white mt-1 rounded-lg border border-solid w-7/12 h-[60px] overflow-hidden justify-center items-start ${
                        i18n.language === "ar"
                          ? "flex-row-reverse"
                          : "" || errorMessage
                            ? "border-red-500"
                            : "border-stone-300"
                      }`}
                    >
                      <span className="inset-y-0 flex items-center ps-3 py-3.5 text-2xl text-black">
                        EGP
                      </span>
                      <input
                        id="textInput2"
                        value={returnDeliveryFee}
                        className="bg-white text-left h-[62px] w-full focus:outline-none ps-2 font-bold text-zinc-800 text-2xl"
                        style={{ direction: "ltr" }}
                        onChange={(e) => {
                          let inputValue = e.target.value;

                          inputValue = inputValue.replace(/ز/g, ".");

                          const sanitizedValue = inputValue.replace(
                            /[^0-9.]/g,
                            "",
                          );

                          if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
                            let numericValue = sanitizedValue;

                            if (numericValue.startsWith(".")) {
                              numericValue = "0" + numericValue;
                            }

                            numericValue =
                              numericValue.replace(/^0+(?=\d)/, "") || "0";

                            if (
                              parseFloat(numericValue) > constReturnDeliveryFee
                            ) {
                              setErrorMessage(
                                `Value cannot exceed ${constReturnDeliveryFee}`,
                              );
                            } else {
                              setErrorMessage(""); // Clear error message
                            }

                            setReturnDeliveryFee(numericValue);
                          }
                        }}
                        onBlur={() => {
                          if (returnDeliveryFee === 0) {
                            setReturnDeliveryFee(0);
                          }
                        }}
                        maxLength={7}
                      />
                    </div>
                  )}

                  {(selectedOrderFrom?.name === "self_delivery" ||
                    selectedPaymentMethod?.name === "COD") && (
                    <div
                      className={`flex bg-white mt-1 rounded-lg border border-solid border-stone-300 h-[60px] overflow-hidden justify-center items-start w-7/12 ${
                        i18n.language === "ar" ? "flex-row-reverse" : ""
                      }`}
                    >
                      <span className="inset-y-0 flex items-center px-3 py-3.5 text-2xl text-black">
                        EGP
                      </span>
                      <input
                        id={"textInput3"}
                        type="number"
                        autoFocus={true}
                        value={deliveryFee}
                        className="bg-white text-left h-[62px] w-full focus:outline-none px-2 font-bold text-zinc-800 text-2xl"
                        style={{ direction: "ltr" }}
                        onFocus={(e) => {
                          if (deviceType === "tablet") {
                            e.target.blur(); // Prevent keyboard from opening on tablet
                          }
                        }}
                        onChange={(e) => {
                          let inputValue = e.target.value;

                          inputValue = inputValue.replace(/ز/g, ".");

                          const sanitizedValue = inputValue.replace(
                            /[^0-9.]/g,
                            "",
                          );

                          if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
                            setDeliveryFee(sanitizedValue);
                          }
                        }}
                        maxLength={7}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div>
                 <SelectBox
                  name="salesman"
                  // label={t("Select Salesman")}
                  defaultValue={null}
                  onChange={(e)=>{
                    setSelectedSalesman(e.target)
                  }}
                  value={selectedSalesman}
                  options={[
                    { value: null, label: t("Select"), disabled: true },
                    ...allSalesman?.map((item) => ({
                      value: item.id,
                      label: `${item.name} (${item?.phone_no})`,
                    })),
                  ]}
                />
              </div>

              {/* Change  */}

              <div
                style={{ direction: "ltr" }}
                className={`flex flex-col mt-8 text-4xl font-bold tracking-wider text-center capitalize text-zinc-800 max-md:mt-7 max-md:w-full ${
                  i18n.language === "ar" ? "ms-16" : ""
                }`}
              >
                {keypadValues.map((row, rowIndex) => (
                  <div
                    key={rowIndex}
                    className="flex mb-3 max-md:flex-wrap max-md:w-full"
                  >
                    {row.map((value, index) => (
                      <KeypadButton
                        key={index}
                        value={value.value}
                        className={value.className}
                        onClick={() => handleKeypadButtonClick(value.value)}
                        isBankPaymentSelected={isBankPaymentSelected}
                        style={value.isIcon ? { padding: "0.1rem" } : null}
                        grandTotal={grandTotal}
                        selectedPaymentMethod={selectedPaymentMethod}
                        orderFromOptions={orderFromOptions}
                      >
                        {value.isIcon ? (
                          <img
                            src={value.icon}
                            alt="icon"
                            style={{ height: "1.5rem", width: "auto" }}
                          />
                        ) : (
                          value.value
                        )}
                      </KeypadButton>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
        <footer></footer>
      </section>
    </div>
  );
}

export default Payment_Modal;





// import * as React from "react";
// import { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axiosInstance from "../../AxiosInstance";
// import { URLS } from "../../API/API endpoints";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   bank_icon_2,
//   bank_method_icon,
//   cash_bank_icon,
//   cash_icon_2,
//   cash_method_icon,
//   clear_icon,
//   credit,
//   credit_blue,
//   delivery_icon,
//   return_icon,
// } from "../../assets";
// import { createOrder } from "../../Redux/Action/createposorderAction";
// import { useTranslation } from "react-i18next";
// import { storeSelectedPaymentMethod } from "../../Redux/Action/paymentAction";
// import { toast } from "react-toastify";
// import i18next from "i18next";
// import { detectWebDeviceType, isTablet } from "../../utils";
// import SelectBox from "../CustomWidgets/SelectBox";

// /* ─────────────────────────────────────────────
//    Inline styles injected once
// ───────────────────────────────────────────── */
// const GLOBAL_STYLES = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');

//   .pm-modal * { box-sizing: border-box; }

//   .pm-modal {
//     font-family: 'DM Sans', sans-serif;
//   }

//   /* spinner */
//   .pm-spinner { display: flex; gap: 8px; }
//   .pm-spinner span {
//     width: 12px; height: 12px;
//     background: #fff;
//     border-radius: 50%;
//     animation: pm-bounce 0.9s ease-in-out infinite;
//   }
//   .pm-spinner span:nth-child(2) { animation-delay: 0.15s; }
//   .pm-spinner span:nth-child(3) { animation-delay: 0.30s; }
//   @keyframes pm-bounce {
//     0%,80%,100% { transform: scale(0.6); opacity: 0.5; }
//     40%          { transform: scale(1);   opacity: 1;   }
//   }

//   /* keypad button hover lift */
//   .pm-key {
//     transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;
//   }
//   .pm-key:not(:disabled):hover {
//     transform: translateY(-2px);
//     box-shadow: 0 6px 18px rgba(0,0,0,0.12);
//   }
//   .pm-key:not(:disabled):active {
//     transform: translateY(0);
//     box-shadow: none;
//   }

//   /* payment pill hover */
//   .pm-pill {
//     transition: all 0.18s ease;
//   }
//   .pm-pill:hover:not(.pm-pill--disabled) {
//     border-color: #1b4597 !important;
//     color: #1b4597 !important;
//     box-shadow: 0 4px 14px rgba(27,69,151,0.15);
//     transform: translateY(-1px);
//   }

//   /* order-from button hover */
//   .pm-order-btn {
//     transition: all 0.18s ease;
//   }
//   .pm-order-btn:hover {
//     filter: brightness(1.08);
//     transform: translateY(-2px);
//     box-shadow: 0 8px 20px rgba(0,0,0,0.15);
//   }

//   /* done button glow */
//   .pm-done-btn {
//     transition: all 0.2s ease;
//     position: relative;
//     overflow: hidden;
//   }
//   .pm-done-btn::after {
//     content: '';
//     position: absolute;
//     inset: 0;
//     background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, transparent 60%);
//     pointer-events: none;
//   }
//   .pm-done-btn:not(:disabled):hover {
//     transform: translateY(-2px);
//     box-shadow: 0 10px 30px rgba(27,69,151,0.40);
//     filter: brightness(1.08);
//   }

//   /* number input remove arrows */
//   .pm-input-no-arrows::-webkit-inner-spin-button,
//   .pm-input-no-arrows::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
//   .pm-input-no-arrows { -moz-appearance: textfield; }

//   /* clear button */
//   .pm-clear-btn {
//     transition: all 0.18s ease;
//   }
//   .pm-clear-btn:not(.pm-clear-btn--disabled):hover {
//     filter: brightness(1.1);
//     transform: translateY(-1px);
//     box-shadow: 0 6px 18px rgba(244,32,32,0.30);
//   }

//   /* section card */
//   .pm-card {
//     background: #fff;
//     border-radius: 16px;
//     border: 1px solid #EBEBF0;
//     box-shadow: 0 2px 8px rgba(0,0,0,0.04);
//   }
// `;

// function injectStyles() {
//   if (document.getElementById("pm-global-styles")) return;
//   const tag = document.createElement("style");
//   tag.id = "pm-global-styles";
//   tag.textContent = GLOBAL_STYLES;
//   document.head.appendChild(tag);
// }

// /* ─────────────────────────────────────────────
//    LoadingSpinner
// ───────────────────────────────────────────── */
// const LoadingSpinner = () => (
//   <div
//     style={{ zIndex: 50 }}
//     className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50"
//   >
//     <div className="pm-spinner">
//       <span></span>
//       <span></span>
//       <span></span>
//     </div>
//   </div>
// );

// /* ─────────────────────────────────────────────
//    Label chip for section headers
// ───────────────────────────────────────────── */
// function SectionLabel({ children }) {
//   return (
//     <p style={{
//       fontSize: 14,
//       fontWeight: 600,
//       letterSpacing: "0.08em",
//       textTransform: "uppercase",
//       color: "#9CA3AF",
//       marginBottom: 10,
//     }}>
//       {children}
//     </p>
//   );
// }

// /* ─────────────────────────────────────────────
//    Value display row
// ───────────────────────────────────────────── */
// function ValueRow({ label, value, highlight, isRtl }) {
//   return (
//     <div style={{
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       padding: "10px 16px",
//       borderRadius: 10,
//       background: highlight ? "linear-gradient(135deg,#EEF3FF 0%,#F5F8FF 100%)" : "#FAFAFA",
//       border: highlight ? "1px solid #C7D6F8" : "1px solid #F0F0F0",
//       marginBottom: 8,
//     }}>
//       <span style={{ fontSize: 16, color: "#6B7280", fontWeight: 500 }}>{label}</span>
//       <span style={{
//         fontSize: 20,
//         fontWeight: 700,
//         color: highlight ? "#1b4597" : "#1F2937",
//         fontFamily: "'DM Mono', monospace",
//         direction: "ltr",
//       }}>{value}</span>
//     </div>
//   );
// }

// /* ─────────────────────────────────────────────
//    OrderFromButton
// ───────────────────────────────────────────── */
// function OrderFromButton({ paymentMethod, selected, onClick, disabled }) {
//   const { t } = useTranslation();

//   const getPaymentMethodName = (method) => {
//     switch (method) {
//       case "self_delivery": return t("Self Delivery");
//       default: return t(method);
//     }
//   };

//   return (
//     <div
//       className="pm-order-btn"
//       onClick={onClick}
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: 8,
//         marginTop: 10,
//         padding: "14px 24px",
//         fontSize: 15,
//         fontWeight: 600,
//         borderRadius: 14,
//         border: selected ? "3px solid rgba(255,255,255,0.6)" : "2px solid rgba(255,255,255,0.25)",
//         boxShadow: selected
//           ? "0 0 0 3px rgba(27,69,151,0.30), 0 6px 20px rgba(0,0,0,0.18)"
//           : "0 2px 8px rgba(0,0,0,0.10)",
//         cursor: disabled ? "not-allowed" : "pointer",
//         opacity: disabled ? 0.5 : 1,
//         backgroundColor: paymentMethod?.background_color || "#7EC242",
//         color: paymentMethod?.text_color || "#fff",
//         letterSpacing: "0.01em",
//         whiteSpace: "nowrap",
//       }}
//     >
//       {getPaymentMethodName(paymentMethod.name)}
//     </div>
//   );
// }

// /* ─────────────────────────────────────────────
//    PaymentButton
// ───────────────────────────────────────────── */
// function PaymentButton({ paymentMethod, selected, onClick, disabled }) {
//   const { t } = useTranslation();

//   const getPaymentMethodName = (method) => {
//     const map = {
//       Cash: t("Cash"), Bank: t("Bank"), COD: t("COD"),
//       "Cash & Bank": t("Cash & Bank"), "Credit Card": t("Credit Card"),
//       InstaPay: t("InstaPay"), Credit: t("Credit"),
//     };
//     return map[method] || t(method);
//   };

//   return (
//     <div
//       className={`pm-pill${disabled ? " pm-pill--disabled" : ""}`}
//       onClick={!disabled ? onClick : undefined}
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 8px",
//         minHeight: 56,
//         borderRadius: 12,
//         border: selected ? "2.5px solid #1b4597" : "1.5px solid #E2E5EB",
//         background: selected
//           ? "linear-gradient(135deg,#EEF3FF 0%,#F0F5FF 100%)"
//           : "#FAFAFA",
//         color: selected ? "#1b4597" : "#4B5563",
//         fontWeight: selected ? 700 : 500,
//         fontSize: 16,
//         textAlign: "center",
//         cursor: disabled ? "not-allowed" : "pointer",
//         opacity: disabled ? 0.5 : 1,
//         lineHeight: 1.3,
//         boxShadow: selected ? "0 4px 14px rgba(27,69,151,0.14)" : "none",
//       }}
//     >
//       {getPaymentMethodName(paymentMethod.name)}
//     </div>
//   );
// }

// /* ─────────────────────────────────────────────
//    KeypadButton
// ───────────────────────────────────────────── */
// function KeypadButton({
//   value, className, onClick, children,
//   isBankPaymentSelected, grandTotal,
//   selectedPaymentMethod, orderFromOptions,
// }) {
//   const isDisabled =
//     isBankPaymentSelected ||
//     grandTotal < 0 ||
//     selectedPaymentMethod?.name === "COD" ||
//     selectedPaymentMethod?.name === "Credit";

//   const isGreen = ["10","20","50","100","200"].includes(String(value));

//   return (
//     <button
//       type="button"
//       className="pm-key"
//       onClick={isBankPaymentSelected || selectedPaymentMethod?.name === "COD" ? null : onClick}
//       disabled={isDisabled}
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         height: 80,
//         width: 148,
//         marginInlineEnd: 10,
//         borderRadius: 12,
//         fontSize: 22,
//         fontWeight: 600,
//         fontFamily: "'DM Mono', monospace",
//         border: isGreen ? "none" : "1px solid #E2E5EB",
//         background: isGreen
//           ? "linear-gradient(135deg,#7EC242 0%,#6BB035 100%)"
//           : "linear-gradient(180deg,#FFFFFF 0%,#F5F5F5 100%)",
//         color: isGreen ? "#fff" : "#1F2937",
//         boxShadow: isGreen
//           ? "0 4px 14px rgba(126,194,66,0.35)"
//           : "0 2px 6px rgba(0,0,0,0.07)",
//         cursor: isDisabled ? "not-allowed" : "pointer",
//         opacity: isDisabled ? 0.4 : 1,
//         letterSpacing: "0.02em",
//       }}
//     >
//       {children || value}
//     </button>
//   );
// }

// /* ─────────────────────────────────────────────
//    Static dummy payment methods
// ───────────────────────────────────────────── */
// const dummyPaymentMethods = [
//   { name: "COD" },
//   { name: "Cash & Bank" },
//   { name: "Credit" },
// ];

// /* ─────────────────────────────────────────────
//    Main Payment_Modal
// ───────────────────────────────────────────── */
// function Payment_Modal({
//   onClose, isCompanyCheckout, grandTotal, handleCheckout,
//   setTenderCash, creditAmount, setCreditAmount,
//   deliveryCheck, deliveryFee, setDeliveryFee,
//   returnDeliveryFee, setReturnDeliveryFee, showReturnDelivery,
//   constReturnDeliveryFee, discountType, setDiscountType,
//   discountValue, setDiscountValue, originalTotal,
//   totalBillAmount, totalCostPrice,
// }) {
//   injectStyles();

//   const { t, i18n } = useTranslation();
//   const deviceType = detectWebDeviceType();
//   const { user } = useSelector((state) => state?.login);

//   const [totalPaid, setTotalPaid] = useState("");
//   const [ReturnTotal, setReturnTotal] = useState("");
//   const [change, setChange] = useState("");
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
//   const [isBankPaymentSelected, setIsBankPaymentSelected] = useState(false);
//   const [paymentMethods, setPaymentMethods] = useState([]);
//   const [orderFromOptions, setOrderFromOptions] = useState([]);
//   const [allSalesman, setAllSalesman] = useState([]);
//   const [selectedSalesman, setSelectedSalesman] = useState(null);
//   const [selectedOrderFrom, setSelectedOrderFrom] = useState();
//   const [loading, setLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [activePaymentIndex, setActivePaymentIndex] = useState(0);
//   const [activeOrderFromIndex, setActiveOrderFromIndex] = useState("");

//   const isETAenabled = useSelector((state) => state?.permissionReducer?.permissions?.is_eta_enabled);
//   const returnProducts = useSelector((state) => state.returnProductReducer.products);
//   const allowDiscount = useSelector((state) => state?.permissionReducer?.permissions?.is_allow_discount);
//   const localProducts = useSelector((state) => state.products.products);

//   const [cashPaid, setCashPaid] = useState(0);
//   const [remainingAmount, setRemainingAmount] = useState(grandTotal);
//   const totalPaidInputRef = React.useRef(null);
//   const getCustomerState = useSelector((state) => state?.getcustomer?.selectedCustomer);
//   const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

//   console.log("localProducts==>", localProducts);

//   const dispatch = useDispatch();

//   const calculateTotalTax = (products) => {
//     return products.reduce((total, product) => {
//       const price = Number(product.price_after_discount) || 0;
//       const qty = Number(product.quantity) || 1;
//       const taxPercentage = isETAenabled && product?.vat_details?.tax_id
//         ? Number(product?.vat_details?.tax_rate_percent) || 0 : 0;
//       const tax = (price * qty * taxPercentage) / (100 + taxPercentage);
//       return total + tax;
//     }, 0);
//   };

//   const totalTax = calculateTotalTax(localProducts);
//   console.log("totalTax===>", totalTax);

//   const getPaymentMethod = async (userID) => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.post(URLS.PAYMENT_METHODS, { user_id: userID });
//       if (response?.data.result.data != null) {
//         const methods = response.data.result.data.map((method) => ({
//           name: method.name, id: method.id, is_cash_bank: method.is_cash_bank,
//           cash_id: method.cash_payment_method_id,
//           bank_id: method.bank_id ?? method.bank_payment_method_id,
//         }));
//         setPaymentMethods([...methods]);

//         let selectedIndex;
//         if (grandTotal <= 0 && returnProducts?.[0]?.payment_method_id) {
//           selectedIndex = methods.findIndex((method) => {
//             const sameId = method.id === returnProducts?.[0]?.payment_method_id;
//             const hasBankId = returnProducts?.[0]?.bank_id != null && method.bank_id != null;
//             if (sameId && hasBankId) return method.bank_id === returnProducts?.[0]?.bank_id;
//             return sameId;
//           });
//         } else {
//           selectedIndex = methods.findIndex((method) => method.name === "Cash");
//         }

//         if (selectedIndex !== -1) {
//           const selectedMethod = methods[selectedIndex];
//           handlePaymentMethodClick(selectedMethod, selectedOrderFrom);
//           setSelectedPaymentMethod(selectedMethod);
//           setActivePaymentIndex(selectedIndex);
//         }
//       }
//     } catch (err) {
//       console.error(err);
//       setErrorMessage("Failed to fetch payment methods.");
//     } finally { setLoading(false); }
//   };

//   const getOrderFrom = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.post(URLS.ORDER_FROM, {
//         user_id: user_id,
//         lang: i18next.language === "ar" ? "ar_001" : "en_US",
//       });
//       const posOrderFrom = response?.data?.result?.[0]?.pos_order_from;
//       setOrderFromOptions(posOrderFrom);
//       setSelectedOrderFrom(posOrderFrom[0]);
//       setActiveOrderFromIndex(0);
//       getOrderFromMethods(posOrderFrom[0]?.id, posOrderFrom[0]);
//     } catch (err) {
//       console.error(err);
//       setErrorMessage("Failed to fetch order from options.");
//     } finally { setLoading(false); }
//   };

//   const getSalesman = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.post(URLS.GET_ALL_SALESMAN, {
//         lang: i18next.language === "ar" ? "ar_001" : "en_US",
//         company_id: user?.result?.company_id,
//         search: "", limit: 100, offset: 0,
//       });
//       if (response?.data?.result?.status_code == 200) {
//         setAllSalesman(response?.data?.result?.data);
//       } else { setAllSalesman([]); }
//     } catch (err) {
//       console.error(err);
//       setErrorMessage("Failed to fetch order from options.");
//     } finally { setLoading(false); }
//   };

//   const getOrderFromMethods = async (id, company) => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.post(URLS.ORDER_FROM_METHOD, {
//         user_id: user_id, pos_order_from_id: id,
//       });
//       if (response?.data?.result?.status_code == 200) {
//         setPaymentMethods(response?.data?.result?.data);
//         const cashIndex = response?.data?.result?.data?.findIndex((method) => method.name === "Cash");
//         console.log("cashIndex===>", company);
//         if (cashIndex !== -1) {
//           handlePaymentMethodClick(response?.data?.result?.data[cashIndex], company);
//           setSelectedPaymentMethod(response?.data?.result?.data[cashIndex]);
//           setActivePaymentIndex(cashIndex);
//         } else {
//           handlePaymentMethodClick(response?.data?.result?.data[0], company);
//         }
//       } else { setPaymentMethods([]); }
//     } catch (err) { console.error(err); } finally { setLoading(false); }
//   };

//   const getCreditAomunt = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.post(URLS.GET_CUSTOMER_CREDIT, { phone: getCustomerState?.mobile });
//       if (response?.data?.result[0].status_code === 200 && response?.data?.result[0].status === "Customer Credits") {
//         setCreditAmount(response?.data?.result[0]);
//       }
//     } catch (err) {
//       console.error(err);
//       setErrorMessage("Failed to fetch credit amount.");
//     } finally { setLoading(false); }
//   };

//   useEffect(() => {
//     if (isCompanyCheckout) getOrderFrom();
//   }, [user?.result?.user_id]);

//   useEffect(() => {
//     if (!deliveryCheck && !isCompanyCheckout) getPaymentMethod(user?.result?.user_id);
//     getSalesman();
//     if (getCustomerState) getCreditAomunt();
//   }, [user?.result?.user_id, getCustomerState]);

//   const keypadValues = [
//     [
//       { value: "1", className: "" },
//       { value: "2", className: "" },
//       { value: "3", className: "" },
//       { value: "10", className: "" },
//     ],
//     [
//       { value: "4", className: "" },
//       { value: "5", className: "" },
//       { value: "6", className: "" },
//       { value: "20", className: "" },
//     ],
//     [
//       { value: "7", className: "" },
//       { value: "8", className: "" },
//       { value: "9", className: "" },
//       { value: "50", className: "" },
//     ],
//     [
//       { value: ".", className: "" },
//       { value: "0", className: "" },
//       { value: "200", className: "" },
//       { value: "100", className: "" },
//     ],
//   ];

//   const handleKeypadButtonClick = (value) => {
//     if (totalPaid.length >= 10 && value !== "C" && value !== "." && !["50","100","200"].includes(value)) return;

//     if (value === "C") {
//       setTotalPaid(""); setTenderCash(0); setChange("");
//     } else if (value === ".") {
//       if (!totalPaid.includes(".")) {
//         setTotalPaid((p) => p + ".");
//         setTenderCash((p) => p + "." || 0);
//       }
//     } else if (!isNaN(parseInt(value, 10))) {
//       if (["50","100","200","20","10"].includes(value)) {
//         const upd = parseFloat(totalPaid || 0) + parseFloat(value);
//         setTotalPaid(upd.toString()); setTenderCash(upd.toString() || 0);
//         const chg = upd - parseFloat(String(grandTotal).replace(/[^0-9.]/g, ""));
//         setChange(`${Math.max(chg, 0)}`);
//       } else {
//         const upd = totalPaid + value;
//         setTotalPaid(upd); setTenderCash(upd || 0);
//         const num = parseFloat(upd.replace(/[^0-9.]/g, ""));
//         const chg = num - parseFloat(String(grandTotal).replace(/[^0-9.]/g, ""));
//         setChange(`${Math.max(chg, 0)}`);
//       }
//       if (selectedPaymentMethod?.name === "Cash & Bank") {
//         const upd = totalPaid + value;
//         const num = parseFloat(upd.replace(/[^0-9.]/g, ""));
//         setRemainingAmount(Math.max(grandTotal - num, 0));
//       }
//     }
//     setErrorMessage("");
//   };

//   const handlePaymentMethodClick = (method, company) => {
//     console.log("companyName==>", company?.name, company?.delivery_fee);
//     console.log("METRHOFFFFFFFF==>", method);

//     if (grandTotal <= 0) setTotalPaid(0);
//     if (company?.name === "self_delivery") {
//       setDeliveryFee(company?.delivery_fee ? company?.delivery_fee : 0);
//     } else if (method.name === "COD") {
//       setDeliveryFee(selectedOrderFrom?.delivery_fee ? selectedOrderFrom?.delivery_fee : 0);
//     } else { setDeliveryFee(null); }

//     dispatch(storeSelectedPaymentMethod(method));
//     setSelectedPaymentMethod(method);
//     setActivePaymentIndex(paymentMethods.indexOf(method));

//     if (method.name === "Cash & Bank") {
//       console.log("SELEDTED METHODDD--->", paymentMethods);
//       const cashMethod = paymentMethods?.find((m) => m.name === "Cash");
//       const bankMethod = paymentMethods?.find((m) => m.name === "Bank" || m.bank_id);
//       if (cashMethod && bankMethod) {
//         method = { name: method.name, id: { cashId: cashMethod.id, bankId: bankMethod.id } };
//         setSelectedPaymentMethod(method);
//       }
//       setIsBankPaymentSelected(false); setCashPaid(0); setRemainingAmount(grandTotal);
//       setTotalPaid(""); setChange("");
//     } else if (
//       method.name === "Bank" || method.name === "Credit Card" || method.name === "InstaPay" ||
//       method.bank_id || method?.name == "COD" || method?.name === "Fawry" ||
//       method?.name === "Prepaid" || method?.name === "PayU" ||
//       method?.name === "Vodafone Cash" || method?.name === "ValU"
//     ) {
//       setIsBankPaymentSelected(true);
//       setTenderCash(String(grandTotal) || 0); setTotalPaid(String(grandTotal)); setChange("0");
//     } else if (method.name === "COD") {
//       const cashMethod = paymentMethods.find((m) => m.name === "Cash");
//       if (cashMethod) { method = { name: method.name, id: cashMethod.id }; setSelectedPaymentMethod(method); }
//       setIsBankPaymentSelected(false); setTotalPaid(0); setTenderCash(0); setChange("0");
//     } else if (method.name === "Credit") {
//       setIsBankPaymentSelected(false); setTotalPaid(0); setTenderCash(0); setChange("0");
//     } else {
//       setIsBankPaymentSelected(false); setTenderCash(0); setTotalPaid(""); setChange("");
//     }
//     setErrorMessage("");
//   };

//   const handleOrderFromClick = (method) => {
//     if (selectedOrderFrom?.id === method?.id) return;
//     getOrderFromMethods(method?.id, method);
//     setSelectedOrderFrom(method);
//     setActiveOrderFromIndex(orderFromOptions.indexOf(method));
//   };

//   const handleCheckoutClick = (event) => {
//     if (errorMessage) {
//       toast.error(t(`The Return Delivery Fee cannot exceed EGP ${constReturnDeliveryFee}`));
//       return;
//     }
//     handleCheckout(selectedPaymentMethod, selectedOrderFrom, selectedSalesman);
//   };

//   const handleClearButtonClick = () => {
//     if (!isBankPaymentSelected) {
//       setTotalPaid(""); setChange(""); setRemainingAmount(0);
//       setDiscountType(""); setDiscountValue(0);
//     }
//   };

//   useEffect(() => {
//     if (grandTotal < 0) { setTotalPaid(grandTotal.toString()); setIsBankPaymentSelected(true); }
//   }, [grandTotal]);

//   const handleKeyPress = (event) => {
//     const normalizedKey = { x: "ء" }[event.key] || event.key;
//     if (event.key === "Enter") {
//       event.preventDefault();
//       if (selectedPaymentMethod?.name === "Cash & Bank" && totalPaid >= grandTotal) return;
//       if ((selectedPaymentMethod?.name === "Cash & Bank" && totalPaid > 0) ||
//           (selectedPaymentMethod?.name === "Cash" && totalPaid >= grandTotal)) {
//         handleCheckoutClick(event);
//       } else if (selectedPaymentMethod?.name === "Bank" && totalPaid == grandTotal) {
//         handleCheckoutClick(event);
//       } else if (selectedPaymentMethod?.name === "COD") {
//         handleCheckoutClick(event);
//       } else if (selectedPaymentMethod?.name === "Credit") {
//         handleCheckoutClick(event);
//       }
//     } else if (event.shiftKey && normalizedKey === "Shift") {
//       event.preventDefault();
//       if ((grandTotal <= 0 && selectedPaymentMethod?.name === "Bank") || grandTotal <= 0) return;
//       const nextIndex = (activePaymentIndex + 1) % paymentMethods.length;
//       setActivePaymentIndex(nextIndex);
//       setSelectedPaymentMethod(paymentMethods[nextIndex]);
//       handlePaymentMethodClick(paymentMethods[nextIndex], selectedOrderFrom);
//     } else if (event.ctrlKey && normalizedKey === "ء") {
//       event.preventDefault();
//       handleClearButtonClick();
//     }
//   };

//   useEffect(() => {
//     window.addEventListener("keydown", handleKeyPress);
//     return () => window.removeEventListener("keydown", handleKeyPress);
//   }, [totalPaid, grandTotal, selectedPaymentMethod, activePaymentIndex, handleClearButtonClick]);

//   useEffect(() => {
//     if (selectedPaymentMethod?.name === "Cash" || selectedPaymentMethod?.name === "Cash & Bank") {
//       totalPaidInputRef.current?.focus();
//     }
//   }, [selectedPaymentMethod]);

//   /* ── computed helpers ── */
//   const isPaidReadOnly =
//     isBankPaymentSelected || grandTotal < 0 ||
//     selectedPaymentMethod?.name == "COD" || selectedPaymentMethod?.name == "Credit" ||
//     selectedPaymentMethod?.name === "Fawry" || selectedPaymentMethod?.name === "Prepaid" ||
//     selectedPaymentMethod?.name === "PayU";

//     console.log('grandTotal==>',grandTotal);
//     console.log('totalPaid==>',(selectedPaymentMethod?.name === "Cash" && totalPaid < grandTotal));
    
//   const isDoneDisabled =
//     (selectedPaymentMethod?.name === "Cash & Bank" && totalPaid <= 0) ||
//     (selectedPaymentMethod?.name === "Cash" && totalPaid < grandTotal) ||
//     (selectedPaymentMethod?.name === "Cash & Bank" && totalPaid >= grandTotal);

//   const isClearDisabled =
//     isBankPaymentSelected || selectedPaymentMethod?.name === "Credit" ||
//     selectedPaymentMethod?.name === "COD" || grandTotal < 0;

//   const isRtl = i18n.language === "ar";

//   /* ── money format helper ── */
//   const fmtMoney = (val) => {
//     if (isRtl && val < 0) return `${(-val).toFixed(2)}-`;
//     return parseFloat(val).toFixed(2);
//   };

//   /* ─────────────────────────────────────────────
//      Render
//   ───────────────────────────────────────────── */
//   return (
//     <div
//       className="pm-modal"
//       style={{
//         position: "fixed", top: 20, left: 0, width: "100%", height: "100%",
//         display: "flex", alignItems: "center", justifyContent: "center",
//         zIndex: 50,
//         backdropFilter: "blur(8px)",
//         WebkitBackdropFilter: "blur(8px)",
//       }}
//     >
//       {loading && <LoadingSpinner />}

//       {/* Backdrop */}
//       <div style={{
//         position: "fixed", inset: 0,
//         background: "rgba(15,23,42,0.55)",
//         zIndex: 40,
//       }} />

//       {/* Modal card */}
//       <section
//         style={{
//           position: "relative",
//           zIndex: 40,
//           background: "#F8F9FC",
//           borderRadius: 24,
//           boxShadow: "0 32px 80px rgba(0,0,0,0.22), 0 0 0 1px rgba(255,255,255,0.08)",
//           padding: "32px 28px 28px",
//           marginTop: 32,
//           width: isCompanyCheckout ? 1520 : 1350,
//           maxWidth: "98vw",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         {/* Header bar */}
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginBottom: 24,
//           paddingBottom: 18,
//           borderBottom: "1px solid #E8EAF0",
//         }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//             <div style={{
//               width: 36, height: 36, borderRadius: 10,
//               background: "linear-gradient(135deg,#1b4597 0%,#2a5ec7 100%)",
//               display: "flex", alignItems: "center", justifyContent: "center",
//             }}>
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//                 <rect x="1" y="4" width="22" height="16" rx="3" ry="3"/>
//                 <line x1="1" y1="10" x2="23" y2="10"/>
//               </svg>
//             </div>
//             <span style={{ fontSize: 20, fontWeight: 700, color: "#111827", letterSpacing: "-0.01em" }}>
//               {t("Payment")}
//             </span>
//           </div>

//           <button
//             type="button"
//             onClick={onClose}
//             style={{
//               background: "#F3F4F6",
//               border: "none",
//               width: 36, height: 36,
//               borderRadius: 10,
//               display: "flex", alignItems: "center", justifyContent: "center",
//               cursor: "pointer",
//               transition: "background 0.15s",
//               color: "#6B7280",
//             }}
//             onMouseEnter={(e) => e.currentTarget.style.background = "#E5E7EB"}
//             onMouseLeave={(e) => e.currentTarget.style.background = "#F3F4F6"}
//           >
//             <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.2} d="M6 18L18 6M6 6l12 12" />
//             </svg>
//           </button>
//         </div>

//         {/* Body */}
//         <main style={{ display: "flex", gap: 0 }}>

//           {/* ── Company Delivery Column ── */}
//           {isCompanyCheckout && (
//             <div style={{
//               borderRight: "1px solid #E8EAF0",
//               paddingRight: 24,
//               marginRight: 24,
//               minWidth: 200,
//             }}>
//               <SectionLabel>{t("Company Delivery")}</SectionLabel>
//               <div style={{ marginTop: 8 }}>
//                 {orderFromOptions.map((method) => (
//                   <OrderFromButton
//                     key={method.id}
//                     paymentMethod={method}
//                     selected={selectedOrderFrom?.id === method.id}
//                     onClick={() => handleOrderFromClick(method)}
//                     disabled={grandTotal <= 0}
//                   />
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* ── Left + Right columns ── */}
//           <div style={{ display: "flex", flex: 1, gap: 28 }}>

//             {/* ── LEFT: labels + done button ── */}
//             <div style={{ width: "50%", display: "flex", flexDirection: "column", gap: 0 }}>

//               {/* Summary card */}
//               <div className="pm-card" style={{ padding: "18px 16px", marginBottom: 16 }}>
//                 <SectionLabel>{t("Summary")}</SectionLabel>

//                 {totalBillAmount != grandTotal && (
//                   <ValueRow label={t("Total Bill")} value={`EGP ${fmtMoney(totalBillAmount)}`} />
//                 )}

//                 <ValueRow
//                   label={t("Grand Total")}
//                   value={
//                     <>
//                       <span>EGP {fmtMoney(grandTotal)}</span>
//                       {isETAenabled && (
//                         <span style={{ fontSize: 12, color: "#9CA3AF", marginLeft: 8, fontWeight: 400 }}>
//                           Tax: EGP {totalTax.toFixed(2)}
//                         </span>
//                       )}
//                     </>
//                   }
//                   highlight
//                 />

//                 <ValueRow
//                   label={selectedPaymentMethod?.name === "Cash & Bank" ? t("Total paid by cash") : t("Total Paid")}
//                   value={
//                     isBankPaymentSelected ? `EGP ${grandTotal.toFixed(2)}`
//                     : grandTotal <= 0 ? "EGP 0.00"
//                     : totalPaid ? `EGP ${parseFloat(totalPaid).toFixed(2)}` : "EGP —"
//                   }
//                 />

//                 {grandTotal > 0 && (
//                   <ValueRow
//                     label={selectedPaymentMethod?.name === "Cash & Bank" ? t("Total paid by bank") : t("Change")}
//                     value={
//                       selectedPaymentMethod?.name === "Cash & Bank"
//                         ? `EGP ${remainingAmount.toFixed(2)}`
//                         : grandTotal < 0
//                           ? `EGP ${grandTotal.toFixed(2)}`
//                           : `EGP ${Number(change).toFixed(2)}`
//                     }
//                   />
//                 )}

//                 {creditAmount?.response && (
//                   <ValueRow label={t("Balance Credit Amount")} value={`EGP ${creditAmount.response}`} />
//                 )}

//                 {showReturnDelivery && (
//                   <ValueRow label={t("Refund Delivery Fee")} value={`EGP ${parseFloat(returnDeliveryFee || 0).toFixed(2)}`} />
//                 )}

//                 {(selectedOrderFrom?.name === "self_delivery" || selectedPaymentMethod?.name === "COD") && (
//                   <ValueRow label={t("Delivery Fee")} value={`EGP ${parseFloat(deliveryFee || 0).toFixed(2)}`} />
//                 )}
//               </div>

           

//               {/* Payment options */}
//               <div className="pm-card" style={{ padding: "16px", marginBottom: 16 }}>
//                 <SectionLabel>{t("Payment Options")}</SectionLabel>
//                 <div style={{
//                   display: "grid",
//                   gridTemplateColumns: "repeat(4, 1fr)",
//                   gap: 8,
//                 }}>
//                   {paymentMethods?.map((method, index) => (
//                     <PaymentButton
//                       key={method.id}
//                       paymentMethod={method}
//                       selected={selectedPaymentMethod?.name === method.name || activePaymentIndex === index}
//                       onClick={() => handlePaymentMethodClick(method, selectedOrderFrom)}
//                     />
//                   ))}
//                 </div>
//               </div>

//               <div style={{ flex: 1 }} />

//               {/* Done button */}
//               <button
//                 className="pm-done-btn"
//                 disabled={isDoneDisabled}
//                 onClick={handleCheckoutClick}
//                 style={{
//                   width: "calc(100% - 10px)",
//                   padding: "20px 0",
//                   fontSize: 22,
//                   fontWeight: 700,
//                   letterSpacing: "0.02em",
//                   color: "#fff",
//                   background: isDoneDisabled
//                     ? "#9CA3AF"
//                     : "linear-gradient(135deg,#1b4597 0%,#2563EB 100%)",
//                   border: "none",
//                   borderRadius: 14,
//                   cursor: isDoneDisabled ? "not-allowed" : "pointer",
//                   boxShadow: isDoneDisabled ? "none" : "0 8px 24px rgba(27,69,151,0.35)",
//                   transition: "all 0.2s ease",
//                 }}
//               >
//                 {t("Done")}
//               </button>
//             </div>

//             {/* ── RIGHT: inputs + keypad ── */}
//             <div style={{ width: "50%", display: "flex", flexDirection: "column" }}>

//               {/* Inputs row */}
//               <div dir={isRtl ? "rtl" : "ltr"} style={{ display: "flex", gap: 24 }}>
//                 <div style={{ flex: 1 }}>

//                   {/* Total Bill input (when different) */}
//                   {/* {totalBillAmount != grandTotal && (
//                     <div style={{ marginBottom: 14 }}>
//                       <SectionLabel>{t("Total Bill")}</SectionLabel>
//                       <div className="pm-card" style={{
//                         display: "flex", alignItems: "center",
//                         height: 52, padding: "0 14px", gap: 8,
//                       }}>
//                         <span style={{ color: "#6B7280", fontSize: 14, fontWeight: 600 }}>EGP</span>
//                         <input
//                           type="number"
//                           className="pm-input-no-arrows"
//                           style={{
//                             flex: 1, border: "none", outline: "none", background: "transparent",
//                             fontSize: 20, fontWeight: 700, color: "#1F2937",
//                             fontFamily: "'DM Mono', monospace", textAlign: "left",
//                           }}
//                           value={isRtl && totalBillAmount < 0 ? `${-totalBillAmount.toFixed(2)}-` : parseFloat(totalBillAmount).toFixed(2)}
//                           readOnly
//                         />
//                       </div>
//                     </div>
//                   )} */}

//                   {/* Grand Total display */}
//                   {/* <div style={{ marginBottom: 14 }}>
//                     <SectionLabel>{t("Grand Total")}</SectionLabel>
//                     <div style={{
//                       display: "flex", alignItems: "center", gap: 10,
//                       padding: "10px 14px",
//                       background: "linear-gradient(135deg,#EEF3FF,#F5F8FF)",
//                       borderRadius: 12, border: "1.5px solid #C7D6F8",
//                     }}>
//                       <span style={{ color: "#1b4597", fontSize: 14, fontWeight: 700 }}>EGP</span>
//                       <span style={{ fontSize: 24, fontWeight: 800, color: "#1b4597", fontFamily: "'DM Mono', monospace", direction: "ltr" }}>
//                         {isRtl && grandTotal < 0 ? `${-grandTotal.toFixed(2)}-` : parseFloat(grandTotal).toFixed(2)}
//                       </span>
//                       {isETAenabled && (
//                         <span style={{ fontSize: 12, color: "#6B7280", marginLeft: 4 }}>
//                           (Tax: EGP {totalTax.toFixed(2)})
//                         </span>
//                       )}
//                     </div>
//                   </div> */}

//                   {/* Total Paid + Clear row */}
//                   <div style={{ marginBottom: 14 }}>
//                     <SectionLabel>
//                       {selectedPaymentMethod?.name === "Cash & Bank" ? t("Total paid by cash") : t("Total Paid")}
//                     </SectionLabel>
//                     <div style={{ display: "flex", gap: 10 }}>
//                       {/* Paid input */}
//                       <div
//                         className="pm-card"
//                         style={{
//                           display: "flex", alignItems: "center",
//                           flex: 1, height: 60, padding: "0 14px", gap: 8,
//                           border: isPaidReadOnly ? "1px solid #EBEBF0" : "2px solid #1b4597",
//                           boxShadow: isPaidReadOnly ? "none" : "0 0 0 3px rgba(27,69,151,0.10)",
//                           flexDirection: isRtl ? "row-reverse" : "row",
//                         }}
//                       >
//                         <span style={{ color: isPaidReadOnly ? "#9CA3AF" : "#1b4597", fontSize: 14, fontWeight: 700, flexShrink: 0 }}>EGP</span>
//                         <input
//                           id="textInput1"
//                           ref={totalPaidInputRef}
//                           type="number"
//                           className="pm-input-no-arrows"
//                           autoFocus
//                           onFocus={deviceType === "tablet" ? (e) => e.target.blur() : undefined}
//                           style={{
//                             flex: 1, border: "none", outline: "none", background: "transparent",
//                             fontSize: 22, fontWeight: 700, color: "#1F2937",
//                             fontFamily: "'DM Mono', monospace", direction: "ltr", textAlign: "left",
//                           }}
//                           value={
//                             isBankPaymentSelected ? grandTotal.toFixed(2)
//                             : grandTotal <= 0 ? "0"
//                             : totalPaid
//                           }
//                           readOnly={isPaidReadOnly}
//                           onChange={(e) => {
//                             let inputValue = e.target.value.replace(/ز/g, ".");
//                             const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
//                             if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
//                               setTotalPaid(sanitizedValue);
//                               setTenderCash(sanitizedValue || 0);
//                               const numericValue = parseFloat(sanitizedValue) || 0;
//                               const grandTotalValue = parseFloat(String(grandTotal).replace(/[^0-9.]/g, "")) || 0;
//                               const changeNumeric = numericValue - grandTotalValue;
//                               setChange(`${Math.max(changeNumeric, 0)}`);
//                               if (selectedPaymentMethod?.name === "Cash & Bank") {
//                                 setRemainingAmount(Math.max(grandTotalValue - numericValue, 0));
//                               }
//                             }
//                           }}
//                           maxLength={7}
//                         />
//                       </div>

//                       {/* Clear button */}
//                       <button
//                         className={`pm-clear-btn${isClearDisabled ? " pm-clear-btn--disabled" : ""}`}
//                         onClick={isClearDisabled ? null : handleClearButtonClick}
//                         style={{
//                           height: 60, padding: "0 20px",
//                           background: isClearDisabled ? "#F3F4F6" : "linear-gradient(135deg,#F42020 0%,#D91A1A 100%)",
//                           color: isClearDisabled ? "#9CA3AF" : "#fff",
//                           border: "none", borderRadius: 12,
//                           fontSize: 15, fontWeight: 700,
//                           cursor: isClearDisabled ? "not-allowed" : "pointer",
//                           flexShrink: 0,
//                           boxShadow: isClearDisabled ? "none" : "0 4px 14px rgba(244,32,32,0.30)",
//                         }}
//                       >
//                         {t("Clear")}
//                       </button>
//                     </div>
//                   </div>

//                   {/* Change / Bank paid */}
//                   {/* {grandTotal > 0 && (
//                     <div style={{ marginBottom: 14 }}>
//                       <SectionLabel>
//                         {selectedPaymentMethod?.name === "Cash & Bank" ? t("Total paid by bank") : t("Change")}
//                       </SectionLabel>
//                       <div className="pm-card" style={{
//                         display: "flex", alignItems: "center",
//                         height: 52, padding: "0 14px", gap: 8,
//                         flexDirection: isRtl ? "row-reverse" : "row",
//                       }}>
//                         <span style={{ color: "#6B7280", fontSize: 14, fontWeight: 600 }}>EGP</span>
//                         <input
//                           type="number"
//                           className="pm-input-no-arrows"
//                           style={{
//                             flex: 1, border: "none", outline: "none", background: "transparent",
//                             fontSize: 20, fontWeight: 700, color: "#1F2937",
//                             fontFamily: "'DM Mono', monospace", direction: "ltr", textAlign: "left",
//                           }}
//                           value={
//                             selectedPaymentMethod?.name === "Cash & Bank"
//                               ? remainingAmount.toFixed(2)
//                               : isRtl && grandTotal < 0
//                                 ? `${-grandTotal.toFixed(2)}-`
//                                 : grandTotal < 0
//                                   ? grandTotal.toFixed(2)
//                                   : Number(change).toFixed(2)
//                           }
//                           readOnly
//                         />
//                       </div>
//                     </div>
//                   )} */}

//                   {/* Credit amount */}
//                   {/* {creditAmount?.response && (
//                     <div style={{ marginBottom: 14 }}>
//                       <SectionLabel>{t("Balance Credit Amount")}</SectionLabel>
//                       <div className="pm-card" style={{
//                         display: "flex", alignItems: "center",
//                         height: 52, padding: "0 14px", gap: 8,
//                       }}>
//                         <span style={{ color: "#6B7280", fontSize: 14, fontWeight: 600 }}>EGP</span>
//                         <input
//                           type="number"
//                           className="pm-input-no-arrows"
//                           style={{
//                             flex: 1, border: "none", outline: "none", background: "transparent",
//                             fontSize: 20, fontWeight: 700, color: "#1F2937",
//                             fontFamily: "'DM Mono', monospace", direction: "ltr", textAlign: "left",
//                           }}
//                           value={creditAmount?.response}
//                           readOnly
//                         />
//                       </div>
//                     </div>
//                   )} */}

//                   {/* Return delivery fee */}
//                   {showReturnDelivery && (
//                     <div style={{ marginBottom: 14 }}>
//                       <SectionLabel>{t("Refund Delivery Fee")}</SectionLabel>
//                       <div
//                         className="pm-card"
//                         style={{
//                           display: "flex", alignItems: "center",
//                           height: 52, padding: "0 14px", gap: 8,
//                           border: errorMessage ? "2px solid #F42020" : "1px solid #EBEBF0",
//                           flexDirection: isRtl ? "row-reverse" : "row",
//                         }}
//                       >
//                         <span style={{ color: "#6B7280", fontSize: 14, fontWeight: 600 }}>EGP</span>
//                         <input
//                           id="textInput2"
//                           className="pm-input-no-arrows"
//                           value={returnDeliveryFee}
//                           style={{
//                             flex: 1, border: "none", outline: "none", background: "transparent",
//                             fontSize: 20, fontWeight: 700, color: "#1F2937",
//                             fontFamily: "'DM Mono', monospace", direction: "ltr", textAlign: "left",
//                           }}
//                           onChange={(e) => {
//                             let inputValue = e.target.value.replace(/ز/g, ".");
//                             const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
//                             if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
//                               let numericValue = sanitizedValue;
//                               if (numericValue.startsWith(".")) numericValue = "0" + numericValue;
//                               numericValue = numericValue.replace(/^0+(?=\d)/, "") || "0";
//                               if (parseFloat(numericValue) > constReturnDeliveryFee) {
//                                 setErrorMessage(`Value cannot exceed ${constReturnDeliveryFee}`);
//                               } else { setErrorMessage(""); }
//                               setReturnDeliveryFee(numericValue);
//                             }
//                           }}
//                           onBlur={() => { if (returnDeliveryFee === 0) setReturnDeliveryFee(0); }}
//                           maxLength={7}
//                         />
//                       </div>
//                       {errorMessage && (
//                         <p style={{ color: "#F42020", fontSize: 12, marginTop: 4 }}>{errorMessage}</p>
//                       )}
//                     </div>
//                   )}

//                   {/* Delivery fee */}
//                   {(selectedOrderFrom?.name === "self_delivery" || selectedPaymentMethod?.name === "COD") && (
//                     <div style={{ marginBottom: 14 }}>
//                       <SectionLabel>{t("Delivery Fee")}</SectionLabel>
//                       <div className="pm-card" style={{
//                         display: "flex", alignItems: "center",
//                         height: 52, padding: "0 14px", gap: 8,
//                         flexDirection: isRtl ? "row-reverse" : "row",
//                       }}>
//                         <span style={{ color: "#6B7280", fontSize: 14, fontWeight: 600 }}>EGP</span>
//                         <input
//                           id="textInput3"
//                           type="number"
//                           className="pm-input-no-arrows"
//                           autoFocus
//                           value={deliveryFee}
//                           style={{
//                             flex: 1, border: "none", outline: "none", background: "transparent",
//                             fontSize: 20, fontWeight: 700, color: "#1F2937",
//                             fontFamily: "'DM Mono', monospace", direction: "ltr", textAlign: "left",
//                           }}
//                           onFocus={(e) => { if (deviceType === "tablet") e.target.blur(); }}
//                           onChange={(e) => {
//                             let inputValue = e.target.value.replace(/ز/g, ".");
//                             const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
//                             if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) setDeliveryFee(sanitizedValue);
//                           }}
//                           maxLength={7}
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Salesman selector */}
//               <div style={{ marginBottom: 16 }}>
//                    {/* Salesman label */}
//               <div style={{ marginBottom: 8 }}>
//                 <SectionLabel>{t("Salesman")}</SectionLabel>
//               </div>
//                 <SelectBox
//                   name="salesman"
//                   defaultValue={null}
//                   onChange={(e) => { setSelectedSalesman(e.target); }}
//                   value={selectedSalesman}
//                   options={[
//                     { value: null, label: t("Select"), disabled: true },
//                     ...allSalesman?.map((item) => ({
//                       value: item.id,
//                       label: `${item.name} (${item?.phone_no})`,
//                     })),
//                   ]}
//                 />
//               </div>

//               {/* ── Keypad ── */}
//               <div style={{ direction: "ltr" }}>
//                 {keypadValues.map((row, rowIndex) => (
//                   <div key={rowIndex} style={{ display: "flex", marginBottom: 10 }}>
//                     {row.map((item, index) => (
//                       <KeypadButton
//                         key={index}
//                         value={item.value}
//                         className={item.className}
//                         onClick={() => handleKeypadButtonClick(item.value)}
//                         isBankPaymentSelected={isBankPaymentSelected}
//                         grandTotal={grandTotal}
//                         selectedPaymentMethod={selectedPaymentMethod}
//                         orderFromOptions={orderFromOptions}
//                       >
//                         {item.value}
//                       </KeypadButton>
//                     ))}
//                   </div>
//                 ))}
//               </div>

//             </div>
//           </div>
//         </main>
//         <footer />
//       </section>
//     </div>
//   );
// }

// export default Payment_Modal;

